import {
  Instance,
  types,
  SnapshotIn,
  SnapshotOut,
  getRoot,
} from 'mobx-state-tree';
import { RootModelType } from './Root';
import { modelWithCRUD } from './utils/modelWithCRUD';

export enum VatType {
  GOOD = 'good',
  SERVICE = 'service',
}

export const VatRate = types.model({
  id: types.union(types.identifier, types.identifierNumber),
  position: types.number,
  code: types.string,
  name: types.string,
  display_name: types.string,
  rate: types.number,
  applies_to_goods: types.boolean,
  applies_to_services: types.boolean,
  countries: types.array(types.string),
  exclude_countries: types.array(types.string),
  require_vat_number: types.boolean,
});

export const VatRateStore = modelWithCRUD('vat-rates', VatRate).named(
  'VatRatesStore'
);

export interface IVatRate extends Instance<typeof VatRate> {}
export interface IVatRateSnapshotIn extends SnapshotIn<typeof VatRate> {}
export interface IVatRateSnapshotOut extends SnapshotOut<typeof VatRate> {}

export const VatRateReference = types.reference(VatRate, {
  get(identifier, parent): any {
    return (getRoot(parent!) as RootModelType).vatRateStore.getItemNaive(
      identifier
    );
  },
  set(value) {
    return value.id;
  },
});
